
import Vue from "vue";
export default Vue.extend({
  name: "AccessDeniedComponent",
  props: {
    title: {
      type: String
    },
    camera_and_microphone: {
      type: Boolean
    },
    /** When true, show Go Back button at top right (e.g. on assessment permission screen) */
    showGoBackRefresh: {
      type: Boolean,
      default: false
    },
    /** When true, show animated hint pointing towards browser camera/mic icon */
    showBrowserHint: {
      type: Boolean,
      default: false
    }
  }
});
